// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol } from "@lg/shared";

export class MenuState {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "UserDefinedConfiguration" as const,
    });
    static readonly __type = 'Llama.MenuState';
    private static valuePromise?: Promise<MenuState.ValueType>;

    static get(): Promise<MenuState.ValueType> {
        if (!this.valuePromise) {
            this.valuePromise = ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Llama', 'MenuState', undefined, 'get', [])
        }

        return this.valuePromise
    }

    static async set(value: MenuState.ValueType): Promise<void> {
        this.valuePromise = Promise.resolve(value)
        await ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Llama', 'MenuState', undefined, 'set', [value])
    }
}

export namespace MenuState {
    export type ValueType = any
}
